module.exports = __webpack_public_path__ + "static/media/redirect.446c0337.svg";